import { useParams, useNavigate, Link } from 'react-router-dom';
import { useEffect } from 'react';

export function EditSchoolPage() {
  const { schoolId } = useParams<{ schoolId: string }>();
  const navigate = useNavigate();

  // Redirect to the school detail page with settings tab
  // The full editing functionality is in the settings tab
  useEffect(() => {
    navigate(`/dashboard/schools/${schoolId}?tab=settings`, { replace: true });
  }, [schoolId, navigate]);

  return null;
}